import { Icon } from '@iconify/react'
import { COUNTRY_FEDERATION_BADGES, COUNTRY_FLAGS, getClub } from '../game'

interface ClubCrestProps {
  name: string
  size?: 'small' | 'medium' | 'large'
}

export function ClubCrest({ name, size = 'medium' }: ClubCrestProps) {
  const definition = getClub(name)
  const federationBadge = COUNTRY_FEDERATION_BADGES[name]
  const countryFlag = COUNTRY_FLAGS[name]
  if (federationBadge) return <img className={`club-crest club-crest--${size}`} src={federationBadge} alt="" aria-hidden="true" />
  if (countryFlag) return <img className={`club-crest club-crest--${size}`} src={countryFlag} alt="" aria-hidden="true" />
  if (!definition) return <span className={`club-crest club-crest--${size} club-crest--fallback`} aria-hidden="true"><Icon icon="mdi:shield-outline" /></span>
  return <img className={`club-crest club-crest--${size}`} src={definition.crest} alt="" aria-hidden="true" />
}
